import React, { FC } from "react";
import { useStore }  from "react-redux";
import { Message }   from "semantic-ui-react";
import Errors        from "../../../domain/fundamentals/message/error/Errors";

interface Props {
  target: string;
}

const ValidatorMessage: FC<Props> = (props: Props) => {
  const errors: Errors = useStore().getState().errors;
  if (!errors.has(props.target)) return null;
  return (
    <>
      <Message negative>
        <p>{ errors.getMessage(props.target) }</p>
      </Message>
    </>
  );
};

export default ValidatorMessage;
